import { isly } from "isly";
export var Millisecond;
(function (Millisecond) {
    var _a;
    _a = isly
        .string("value", /^[0-9]{3}$/)
        .rename("isoly.Time.Millisecond")
        .describe("Milliseconds expressed as 3 digits left padded with zeros when required.")
        .bind(), Millisecond.type = _a.type, Millisecond.is = _a.is, Millisecond.flawed = _a.flawed;
    let Numeric;
    (function (Numeric) {
        var _a;
        _a = isly
            .number("range", 0, 999)
            .rename("isoly.Time.Millisecond.Numeric")
            .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    })(Numeric = Millisecond.Numeric || (Millisecond.Numeric = {}));
    function parse(value) {
        return Millisecond.Numeric.type.get(Number.parseInt(value));
    }
    Millisecond.parse = parse;
    function create(value) {
        return Millisecond.type.get(value.toString().padStart(3, "0"));
    }
    Millisecond.create = create;
})(Millisecond || (Millisecond = {}));
//# sourceMappingURL=Millisecond.js.map